import { getENV } from '@libs/common-next';

export const gtmConfig = {
    ca: {
        gtmContainerId: getENV('NEXT_PUBLIC_GTM_CA_CONTAINER_ID'),
        gtmPreview: getENV('NEXT_PUBLIC_GTM_CA_PREVIEW'),
        gtmAuth: getENV('NEXT_PUBLIC_GTM_CA_AUTH'),
    },
    us: {
        gtmContainerId: getENV('NEXT_PUBLIC_GTM_US_CONTAINER_ID'),
        gtmPreview: getENV('NEXT_PUBLIC_GTM_US_PREVIEW'),
        gtmAuth: getENV('NEXT_PUBLIC_GTM_US_AUTH'),
    },
} as const;

export enum Events {
    VIEW_PAGE_SECTION = 'view_page_section',
    VIEW_ITEM_LIST = 'view_item_list',
}

export enum LoginEvents {
    SIGN_IN_DRAWER = 'login modal',
    REAUTHENTICATE_SIGN_IN_DRAWER = 'reauthenticate login modal',
    LOGIN_PAGE = 'login page',
    REAUTHENTICATE_LOGIN_PAGE = 'reauthenticate login page',
    CHECKOUT = 'checkout',
    REAUTHENTICATE_CHECKOUT = 'reauthenticate checkout',
}
